// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../microservices/playlist/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chick-fil-a-dashboard-tag-button[data-v-2494b7b6]{margin-top:-15px;margin-right:37px}.chick-fil-a-playlist-tag-button[data-v-2494b7b6]{margin-left:31px}", ""]);
// Exports
module.exports = exports;
